import type { LearnerMe } from "./api"

export type LearnerPage =
  | "account"
  | "analytics"
  | "billing"
  | "feedback"
  | "support"
  | "home"
  | "mastery"
  | "path"

export type LearnerAccess =
  | { status: "ready" }
  | { status: "account_restricted" }
  | { status: "enrollment_required" }
  | { status: "guardian_required" }
  | { status: "terms_acceptance_required" }
  | { status: "progress_disabled" }
  | { status: "recommendations_disabled" }

export function resolveLearnerAccess(me: LearnerMe, page: LearnerPage): LearnerAccess {
  if (page === "account" || page === "billing" || page === "feedback" || page === "support") {
    return { status: "ready" }
  }
  if (me.owner.status === "deactivated" || me.owner.status === "restricted") {
    return { status: "account_restricted" }
  }
  if (!me.accountContext.currentTermsAccepted) return { status: "terms_acceptance_required" }
  if (me.enrollment.status !== "active" || me.owner.status === "pending") {
    return { status: "enrollment_required" }
  }
  if (me.consent.required && !me.consent.active) return { status: "guardian_required" }
  if (
    (page === "home" || page === "mastery" || page === "analytics") &&
    !me.capabilities.progress
  ) {
    return { status: "progress_disabled" }
  }
  if (page === "path" && !me.capabilities.recommendations) {
    return { status: "recommendations_disabled" }
  }
  return { status: "ready" }
}
